module.exports = "/_next/static/images/img__santa-07cb61ad66658165ddbd9d3a84081fdb.png";